
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import CreateUUID from "../guid";

    @Component
    export default class PopoverInfo extends Vue {
        @Prop({ required: false, default: () => CreateUUID() })
        id!: string;
    }
